.switchWrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px; /* Spacing between the toggle and the text */
	padding: 10px; /* Spacing inside the container */
}

.switch {
	position: relative;
	display: inline-block;
	flex-shrink: 0;
	width: 50px;
	height: 30px;
}

.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ccc;
	transition: 0.4s;
	border-radius: 30px; /* Ellipsoid shape */
}

.slider:before {
	position: absolute;
	content: "";
	height: 24px;
	width: 24px;
	left: 3px;
	bottom: 3px;
	background-color: white;
	transition: 0.4s;
	border-radius: 50%; /* Ellipsoid shape */
}

input:checked + .slider {
	background-color: #0277ad;
}

input:checked + .slider:before {
	transform: translateX(20px);
}
